export default "__VITE_ASSET__pOJmaygE__"